import { getSimpleDataSelector } from '@cp-shared-10/frontend-integration';
import { RootState } from 'store/rootReducer';

export const CustomerTypeDataSelector = getSimpleDataSelector((state: RootState) => state.customerType);
